import { ConvertMeterType, convertMetersToUnits } from '../../commonUtils';
import { roundSafe } from './roundSafe';

/**
 * Converts a value from metric to imperial units (if required) and rounds the result
 * @param value - The numeric value to convert and round
 * @param convertUnits - Flag indicating whether to convert units
 * @param unitToConvertTo - The target unit type for conversion
 * @param isPerMeter - Flag indicating if the value is per meter or a direct conversion
 * @param roundDigits - Number of decimal places to round to
 * @returns The converted and rounded number, or null if input is null/undefined
 */

export const convertAndRound = (
  value: number | null | undefined,
  convertUnits: boolean,
  unitToConvertTo: ConvertMeterType,
  isPerMeter: boolean,
  roundDigits: number
): number | null => {
  if (value == null) return null;

  const convertedValue = convertUnits
    ? convertMetersToUnits(value, isPerMeter, unitToConvertTo)
    : value;
  return roundSafe(convertedValue, roundDigits);
};
